
const MintPage =() => {

    return(
    <div className="mintpage">
        <h1>MintPage</h1>
    </div>
    )
}
export default MintPage;